import React, { Component } from 'react';

export default class Speaker extends Component {
  render() {
    let speaker = this.props.speakerData;

    let speakerCompany = [];
    if (speaker.company.name) {
      speakerCompany.push(
        <a target='_blank' className='speaker__company' href={speaker.company.url}>
          {speaker.company.name}
        </a>
      );
      speakerCompany.push(', ');
    }
    return (
      <div className='speaker__info' key={speaker.idStr}>
        <a href={'/speaker?id=' + speaker.idStr}>
          <img className='speaker__photo' src={speaker.pictureUrl} alt={speaker.userView.fullName} />
        </a>
        <div className='speaker__name'>
          <a href={'/speaker?id=' + speaker.idStr} className='speaker__name'>
              {speaker.userView.fullName}
          </a>
        </div>
        <div className='speaker__position'>
          {speakerCompany}
          {
            [speaker.jobPosition, speaker.userView.cityName].filter(value => value).join(', ')
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/speakers-page/components/Speaker.js